// importing the action types and a updateObject helper
import*as actionTypes from'../actions/actionTypes';var initialState={};var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];// must return the same state or an updated version
switch(action.type){// set user auth
case actionTypes.SET_AUTH:return Object.assign({},state,action.user);// clear user auth
case actionTypes.CLEAR_AUTH:return{};case actionTypes.SHOW_AUTH_DIALOG:return Object.assign({},state,{authDialog:{status:action.status}});case actionTypes.HIDE_AUTH_DIALOG:return Object.assign({},state,{authDialog:null});default:return state;}};export default reducer;


//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/auth.js
// module id = 1866
// module chunks = 29